import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Badge } from "@/components/ui/badge";

const CATS = ["all", "coffee", "non-coffee", "food", "seasonal"];

export default function Menu() {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const r = await api.get("/menu", { params: cat !== "all" ? { category: cat } : {} });
      setItems(r.data);
      setLoading(false);
    })();
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 lg:pt-28 pb-24">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-8">
          <p className="label-eyebrow text-[hsl(var(--sk-primary))]">{t("menu.eyebrow")}</p>
          <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter">{t("menu.title")}</h1>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mb-12" data-testid="menu-filters">
        {CATS.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`menu-cat-${c}`}
            className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest transition-colors ${
              cat === c ? "bg-[hsl(var(--sk-primary))] text-white" : "bg-[hsl(var(--sk-muted))] text-[hsl(var(--sk-fg))]/70 hover:bg-[hsl(var(--sk-secondary))]"
            }`}>
            {t(`menu.${c}`)}
          </button>
        ))}
      </div>

      {loading ? <p className="text-[hsl(var(--sk-muted-fg))]">Loading…</p> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="menu-grid">
          {items.map((m) => (
            <article key={m.id} data-testid={`menu-item-${m.id}`} className="group">
              <div className="aspect-square rounded-2xl overflow-hidden bg-[hsl(var(--sk-muted))] mb-4">
                {m.image_url && <img src={m.image_url} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
              </div>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl tracking-tight">{lang === "id" ? m.name_id : m.name_en}</h3>
                  <p className="mt-1 text-sm text-[hsl(var(--sk-muted-fg))]">{lang === "id" ? m.description_id : m.description_en}</p>
                  {m.tags?.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {m.tags.map((tag) => (
                        <Badge key={tag} variant="outline" className="text-[10px] uppercase tracking-widest border-[hsl(var(--sk-border))]">{tag}</Badge>
                      ))}
                    </div>
                  )}
                </div>
                <p className="font-mono-stat text-sm shrink-0">{formatIDR(m.price)}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
